var card_default = {
  "link": "AfDZY",
  "container": "ZkDLv",
  "cardLayout": "vTRrx",
  "imageEnd": "-fsom",
  "imageStart": "RxSGh",
  "imageTop": "Ub511",
  "right": "_1VuZM",
  "ltr": "Vrukr",
  "rtl": "gffAP",
  "imageContainer": "hZLND",
  "image": "kfi6X",
  "responsiveImage": "Zqqx3",
  "squareImage": "-lDPz",
  "rectangleImage": "DPr3a",
  "squareRatio": "_79zp7",
  "rectangleRatio": "YuOHq",
  "imageFill": "WA200",
  "imageFit": "XyMiA",
  "imageRibbon": "iXRv3"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
